import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[appMultiSelectCustomTrigger]',
  standalone: true,
})
export class MultiSelectCustomTriggerDirective {
  public readonly templateRef = inject(TemplateRef);

  public static ngTemplateContextGuard(
    _: MultiSelectCustomTriggerDirective,
    _context: unknown
  ): _context is {
    $implicit: {
      openedDropdown: boolean;
    };
  } {
    return true;
  }
}
